import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { Timestamp } from 'firebase/firestore';

dayjs.extend(calendar);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(localizedFormat);

export function formatDateTimeSmart(val: any): string {
  if (!val) return '—';
  let date: dayjs.Dayjs;
  if (val instanceof Date) date = dayjs(val);
  else if (typeof val === 'string' || typeof val === 'number') date = dayjs(val);
  else if (val instanceof Timestamp) date = dayjs(val.toDate());
  else if (val.toDate) date = dayjs(val.toDate());
  else return '—';
  if (!date.isValid()) return '—';
  if (date.isToday()) return date.format('HH:mm');
  if (date.isYesterday()) return `Yesterday, ${date.format('HH:mm')}`;
  if (date.year() === dayjs().year()) return date.format('MMM D, HH:mm');
  return date.format('YYYY-MM-DD HH:mm');
}

export function formatDateLocale(val: any, lang: string = 'en-US'): string {
  if (!val) return '—';
  let date: Date;
  if (val instanceof Date) date = val;
  else if (typeof val === 'string' || typeof val === 'number') date = new Date(val);
  else if (val?.toDate) date = val.toDate();
  else return '—';
  if (isNaN(date.getTime())) return '—';
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
  };
  return date.toLocaleDateString(lang, options);
} 